var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isOnline)?_c('div',{staticClass:"bg-primary fixed-bottom p-2"},[_c('div',{staticClass:"text-center text-white"},[_c('i',{staticClass:"material-icons align-middle"},[_vm._v("cloud_off")]),_vm._v(" "+_vm._s(_vm.$t('pwa.offline'))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }